let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kJ4C4")).then(() => parcelRequire('itCtY'));